import * as yup from "yup";

export type FormValues = {
  publicName?: string;
  organizationName: string;
  identificationCode: string;
  iban: string;
  isSuspended: boolean;
};

export const validationSchema = yup.object({
  organizationName: yup
    .string()
    .required("Вкажіть 'Юридичну назву компанії або ФОП'"),
  identificationCode: yup
    .string()
    .min(8, "'ЄДРПОУ/РНОКПП' має містити 8 або більше символів")
    .max(13, "'ЄДРПОУ/РНОКПП' має містити менше ніж 13 символів")
    .required("Вкажіть 'ЄДРПОУ/РНОКПП'"),
  iban: yup
    .string()
    .min(29, "'IBAN' має містити 29 символів")
    .max(29, "'IBAN' має містити 29 символів")
    .matches(/^UA\d{2}\d{6}\d{5}\d{14}$/, "Неправильний формат 'IBAN'")
    .required("Вкажіть 'IBAN'"),
  isSuspended: yup.boolean().required(),
  publicName: yup
    .string()
    .max(70, "'Публічна назва' має містити менше ніж 70 символів"),
});
